import { Box, Typography } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';
import React from 'react';

/**
 * ListBoxProps
 */
export interface ListBoxProps {
  title?: string;
  subtitle?: string;
  elements: string[];
  info?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    MuiListItem: {
      alignItems: 'baseline',
      padding: 0
    },
    listWrapper: {
      backgroundColor: CORPORATE_COLORS.BACKGROUND_PRIMARY_MEDIUM,
      borderRadius: theme.spacing(2),
      padding: theme.spacing(2.5)
    },
    subtitle: {
      paddingBottom: 2
    },
    list: {
      padding: 0
    }
  })
);

const ListBox = ({ title, subtitle, elements, info }: ListBoxProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <>
      {title && (
        <Typography variant="subtitle1">
          <Box className={classes.subtitle}>
            {title} {!!subtitle && subtitle}
          </Box>
        </Typography>

        //<Typography component='div'>Normal text <Box fontWeight='fontWeightMedium' display='inline'>medium font weight text</Box> and some more normal text</Typography>
      )}
      <Box className={classes.listWrapper}>
        <List className={classes.list}>
          {elements.map((text, id, entries) => (
            <ListItem className={classes.MuiListItem} key={id} disableGutters={true}>
              {entries.length > 1 && (
                <Box fontWeight="fontWeightBold" mr={1}>
                  <Typography>{id + 1}.</Typography>
                </Box>
              )}
              <ListItemText>
                <Typography dangerouslySetInnerHTML={{ __html: text }} />
              </ListItemText>
            </ListItem>
          ))}
        </List>

        {info && (
          <Box pt={2.5}>
            <Typography>
              <strong>Hinweis:</strong>
            </Typography>
            <Typography>{info}</Typography>
          </Box>
        )}
      </Box>
    </>
  );
};

export { ListBox };
